(() => {
  const init = () => {
    const slider = tns({
      container: '[data-testimony-cards-list]',
      items: 1,
      nav: true,
      navPosition: 'bottom',
      mouseDrag: true,
      swipeAngle: false,
      responsive: {
        1: {
          disable: false
        },
        741: {
          disable: true
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();